// src/sections/ModuleSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, Grid, Input, Button, VStack } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";

export default function ModuleSection({ selectedAnlageId }) {
  const [modules, setModules] = useState([
    { hersteller: "", typ: "", leistungWp: "", art: "", anzahl: "" },
  ]);
  const [herstellerList, setHerstellerList] = useState([]);

  // ✅ LOAD existing data
  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/module/anlage/${selectedAnlageId}`)
      .then((res) => {
        setModules(
          res.data.length
            ? res.data
            : [{ hersteller: "", typ: "", leistungWp: "", art: "", anzahl: "" }]
        );
      })
      .catch(() => {
        setModules([{ hersteller: "", typ: "", leistungWp: "", art: "", anzahl: "" }]);
      });
  }, [selectedAnlageId]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/hersteller`)
      .then((res) => setHerstellerList(res.data))
      .catch((err) => console.error("Error loading Hersteller:", err));
  }, []);

  const handleSave = async () => {
    try {
      const filledModules = modules.filter(
        (m) => m.hersteller && (m.typ || m.leistungWp || m.art || m.anzahl)
      );
      for (const module of filledModules) {
        if (module.id) {
          await axios.put(`${process.env.REACT_APP_API_URL}/api/module/${module.id}`, {
            ...module,
            anlage: { id: selectedAnlageId },
          });
        } else {
          await axios.post(`${process.env.REACT_APP_API_URL}/api/module`, {
            ...module,
            anlage: { id: selectedAnlageId },
          });
        }
      }
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/module/anlage/${selectedAnlageId}`
      );
      setModules(res.data);
      showSuccess("Erfolg!", "Module gespeichert oder aktualisiert.");
    } catch {
      showError("Fehler!", "Speichern fehlgeschlagen.");
    }
  };

  const handleDelete = async (id) => {
    await axios.delete(`${process.env.REACT_APP_API_URL}/api/module/${id}`);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...modules];
    updated[index][name] = value;
    setModules(updated);
  };

  const addRow = () =>
    setModules((prev) => [
      ...prev,
      { hersteller: "", typ: "", leistungWp: "", art: "", anzahl: "" },
    ]);

  const removeRow = (index) =>
    setModules((prev) => prev.filter((_, i) => i !== index));

  return (
       <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="fit-content"
    >
      <Heading fontSize="21px" mb={6} color="black.600">
        MODULE
      </Heading>

      <VStack spacing={4} align="stretch">
        {modules.map((m, index) => (
          <Grid
            key={index}
            templateColumns="repeat(5, 1fr) 60px"
            gap={4}
            alignItems="center"
            bg="gray.50"
            p={4}
            rounded="lg"
          >
            <select
              name="hersteller"
              value={m.hersteller}
              onChange={(e) => handleChange(index, e)}
            >
              <option value="">Hersteller wählen</option>
              {herstellerList.map((h) => (
                <option key={h.id} value={h.name}>
                  {h.name}
                </option>
              ))}
            </select>

            <Input name="typ" placeholder="Typ" value={m.typ} onChange={(e) => handleChange(index, e)} />
            <Input name="leistungWp" placeholder="Leistung-Wp" value={m.leistungWp} onChange={(e) => handleChange(index, e)} />
            <Input name="art" placeholder="Art" value={m.art} onChange={(e) => handleChange(index, e)} />
            <Input name="anzahl" placeholder="Anzahl" value={m.anzahl} onChange={(e) => handleChange(index, e)} />

            <Button
              bg="#B22222" // Firebrick red (similar depth to your gold)
              color="white"
              _hover={{ bg: "#D22B2B" }} // Slightly lighter red on hover
              size="md"
              width="fit-content"
              onClick={() => {
                removeRow(index);
                if (m.id) handleDelete(m.id);
              }}
            >
              Löschen
            </Button>
          </Grid>
        ))}

        <Button bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          size="md" onClick={addRow}>
          + Neues Modul
        </Button>

        <Button
          bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          width="fit-content"
          size="md"
          onClick={handleSave}>
          Speichern Module
        </Button>
      </VStack>
    </Box>
  );
}